module.exports = __webpack_public_path__ + "static/video-50c5ba8ed9a4949068c67cdb92e0e4a0.png";